/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { PostSignInError } from './PostSignInError';

export class VodPlayActionError extends PostSignInError {
    protected type: string = 'VodPlayActionError';

    public constructor(
        code: string,
        message: string,
        description: string,
        title: string,
        type: string,
    ) {
        super(message, code);
        this.description = description;
        this.title = title;
        this.type = type;
    }

    public getDescription(): string {
        return this.description;
    }

    public getTitle(): string {
        return this.title;
    }

    public getType(): string {
        return this.type;
    }
}
